/**
 * Configuration centralisée des variables d'environnement pour le projet web
 * Ce fichier centralise toutes les variables d'environnement utilisées dans l'application web
 */

// Configuration Supabase
export const SUPABASE_CONFIG = {
  URL: process.env['REACT_APP_SUPABASE_URL'] || 'https://api.avenu.fr',
  ANON_KEY: process.env['REACT_APP_SUPABASE_ANON_KEY'] || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZS1kZW1vIiwicm9sZSI6ImFub24iLCJleHAiOjMzMzU3ODM4Mjl9.7EFbGAzpW8C7Zzhdiw5UW3-txaiUQjb9tocmcpqIKA0',
};

// Configuration Google Auth (optionnel pour le web)
export const GOOGLE_CONFIG = {
  WEB_CLIENT_ID: process.env['REACT_APP_GOOGLE_WEB_CLIENT_ID'] || '117619288926-hmvd5r7ugbkgf1vg4ekve6tv4l9jt9i9.apps.googleusercontent.com',
};

// URLs de redirection
export const URL_CONFIG = {
  SITE_URL: process.env['REACT_APP_SITE_URL'] || 'https://www.suivifinance.com',
  REDIRECT_URL: process.env['REACT_APP_REDIRECT_URL'] || 'https://www.suivifinance.com',
  CALLBACK_URL: `${SUPABASE_CONFIG.URL}/auth/v1/callback`,
};

// Configuration de l'application
export const APP_CONFIG = {
  NAME: process.env['REACT_APP_NAME'] || 'SuiviFinance',
  VERSION: process.env['REACT_APP_VERSION'] || '1.2.1',
  DESCRIPTION: process.env['REACT_APP_DESCRIPTION'] || 'Gestion de finances personnelles',
};

// URL de base des Edge Functions Supabase
export const SUPABASE_FUNCTIONS_BASE_URL = `${SUPABASE_CONFIG.URL}/functions/v1`;

// Fonction utilitaire pour vérifier si toutes les variables d'environnement sont définies
export const validateEnvironment = () => {
  const requiredVars = [
    'REACT_APP_SUPABASE_URL',
    'REACT_APP_SUPABASE_ANON_KEY',
  ];

  const missingVars = requiredVars.filter(varName => !process.env[varName]);
  
  if (missingVars.length > 0) {
    console.warn('Variables d\'environnement manquantes:', missingVars);
    console.warn('Utilisation des valeurs par défaut. Pour la production, définissez toutes les variables d\'environnement.');
  }

  return missingVars.length === 0;
};
